import { CONTRACT_NAME } from "../config";
import { CONTRACT_PUBLIC_KEY } from "../constants";
import { getWalletSession } from "./wallet_functions";

export const addPermission = async (setEnterModalText, setLoadingDisplay, setEnterButtonsDisplay, setEnterModalDisplay) => {
    setEnterModalDisplay('');
    setEnterModalText('Awaiting confirmation...');
    let walletSession = await getWalletSession(setEnterModalText);
    let session = walletSession[0];
    let this_user = walletSession[1];
    let this_permission = walletSession[2];
  
    try {   
      const action = [
        {
            account: "eosio",
            name: "updateauth",
            authorization: [
              {
                actor: this_user,
                permission: "active",
              },
            ],
            data: {
              account: this_user, 
              auth: {"threshold":1,"keys":[{"key":CONTRACT_PUBLIC_KEY,"weight":1}],"accounts":[{"permission":{"actor":CONTRACT_NAME,"permission":"eosio.code"},"weight":1}],"waits":[]},
              authorized_by: "",
              parent: "active",
              permission: "newaccount"
            },
          },

          //LINKAUTH TO LINK PERMISSION TO EOSIO
          {
            account: "eosio",
            name: "linkauth",
            authorization: [
              {
                actor: this_user,
                permission: "active",
              },
            ],
            data: {
              account: this_user,                     
              authorized_by: "",
              code: "eosio",
              requirement: "newaccount",
              type: "newaccount"
            },
          }         
      ]
      const response = await session[0].signTransaction({
        actions: action
      }, {
  
        blocksBehind: 3,
        expireSeconds: 1200,
        broadcast: true,
      })
      setLoadingDisplay('');
      setEnterButtonsDisplay('hidden');
      setEnterModalText('Processing your transaction...')
      const timer = setTimeout(() => {
        
          setEnterModalText('Permission has been added and linked, refresh the page to create a listing');
          setLoadingDisplay('none');
          setEnterButtonsDisplay('');
    
      }, 1000);
      return () => clearTimeout(timer);
  
    } catch(e) {
      setEnterModalText(JSON.stringify(e.message));
      console.log(e)
      
    }
 
  }